import './ucsandiego/style';
import FormStructure from './ucsandiego/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js